import { ServerEnv } from 'shared/sharedTypes/common/misc';
// just importing a type so yes we want the import to come from frontend so if things change frontendV2 is notified
// eslint-disable-next-line no-restricted-imports
import { CurrentUser, User } from '../../../frontend/scripts/common/system';
// just importing a type so yes we want the import to come from frontend so if things change frontendV2 is notified
// eslint-disable-next-line no-restricted-imports
import { RenderMenuParams } from '../../../frontend/scripts/common/components/FFMenuV2/RenderMenuParams';

declare global {
    interface Window {
        currentUser?: CurrentUser;
        serverEnv?: ServerEnv;
        featureFlags?: { [key: string]: boolean };
        theme?: string;
        timezoneSetting?: string;
        initializedNavMenuState?: RenderMenuParams['initialize']['initializedState'];
        navMenuSizeLocked: RenderMenuParams['initialize']['navMenuSizeLocked'];
        //These two are only loaded when NOT local dev. (Loaded in ffweb-head.hbs)
        segmentToken: string;
        segmentCategory: 'FFWeb';
    }
}

export function isFeatureEnabled(feature: string) {
    return (
        (window && window.featureFlags && window.featureFlags[feature]) || false
    );
}

export function getAccountUuid(currentUser?: CurrentUser) {
    const user = currentUser || (window && window.currentUser) || null;
    return user && user.accountUuid;
}

export function getParentUuid(currentUser?: CurrentUser) {
    const user: Partial<User> =
        currentUser || (window && window.currentUser) || null;
    return user && user.parentUuid;
}

export function hasLicense(
    license: string | RegExp,
    user: CurrentUser = window.currentUser
) {
    if (!user) return false;
    if (license instanceof RegExp) {
        return Boolean(
            Object.entries(user).find(
                ([key, value]) => value && license.exec(key)
            )
        );
    } else {
        return Boolean(user[license as keyof CurrentUser]);
    }
}

export function getStaticUrl(url: string): string {
    switch (window.serverEnv) {
        //beta and prod will pull from here
        case 'prod':
        case 'govprod':
            return `https://static.plan.foreflight.com/${url}`;
        default:
            //Note apollo will also fall into qa
            return `https://static.plan.qa.foreflight.com/${url}`;
    }
}
